module.exports = __webpack_public_path__ + "06873076832eb573480f97dbdcfa1e5e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/skull_divider.png
// module id = 532
// module chunks = 0